import { render, staticRenderFns } from "./emailmessages.vue?vue&type=template&id=397bf3c7&"
import script from "./emailmessages.vue?vue&type=script&lang=js&"
export * from "./emailmessages.vue?vue&type=script&lang=js&"
import style0 from "./emailmessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports